import { If, makeClassName, Row } from "@hex-insights/core";
import { Route, RouteSwitch, useActivePageRegistration } from "@hex-insights/router";
import { MessageGroupUtilities } from "@hex-insights/verita-romania.shared";
import { Main } from "../../Components";
import { MessageGroupsList } from "./Components";
import { MessagingCreatePage } from "./CreatePage";
import { messagingCreatePageInfo } from "./CreatePage/pageinfo";
import { MessagingIndexPage } from "./IndexPage";
import { messagingIndexPageInfo } from "./IndexPage/pageinfo";
import { MessagingMessageGroupPage } from "./MessageGroup";
import { messagingMessageGroupPageInfo } from "./MessageGroup/pageinfo";
import { messagingPageInfo } from "./pageinfo";
import styles from "./styles.module.css";

export function MessagingPage() {
	useActivePageRegistration(messagingPageInfo);

	const isWide = MessageGroupUtilities.useIsScreenWideForSideList();

	return (
		<Main className={styles["messaging-page"]}>
			<Row justify="spaced-start">
				<If condition={isWide}>
					<div className={styles["messaging-page__message-groups-list__container"]}>
						<MessageGroupsList style={{ height: "100%", overflow: "hidden" }} />
					</div>
				</If>

				<div className={makeClassName(styles["messaging-page__sub-pages__container"])}>
					<RouteSwitch>
						<Route {...messagingIndexPageInfo.routeProps}>
							<MessagingIndexPage />
						</Route>
						<Route {...messagingCreatePageInfo.routeProps}>
							<MessagingCreatePage />
						</Route>
						<Route {...messagingMessageGroupPageInfo.routeProps}>
							<MessagingMessageGroupPage key={messagingMessageGroupPageInfo.useKey()} />
						</Route>
					</RouteSwitch>
				</div>
			</Row>
		</Main>
	);
}
